<template>
  <div class="tw-w-full tw-flex tw-justify-center container-background">
    <loading v-show="loadingPage || loadingLote"></loading>
    <div v-if="naoEncontradoLoteAberto">
      <nao-encontrado v-if="naoEncontradoLoteAberto" :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado>
    </div>
    <div v-else>
      <transition name="fade">
        <div
          v-show="!loadingPage && !loadingLote"
          class="tw-w-full tw-px-8 jr:tw-max-w-[1310px] md:tw-py-16 tw-py-8 tw-justify-center tw-grid tw-grid-cols-1 tw-space-y-8 md:tw-space-y-0 md:tw-gap-12 tw-gap-4 tw-font-poppins">
          <bread-crumb
            :categorialeilao="leilao.categorialeilao"
            :nomeLeilao="leilao.nm"
            :nomeLote="lote.nu"
          ></bread-crumb>
          <header-disputa
            :dadosLeilao="dadosLeilao"
            :dadosModeradorId="dadosModeradorId"
            :loteid="loteId"
            :leilaoid="leilaoId"
            :lotes="navegacao.lotes_combo"
            :lote="lote"
            :liberado="liberado"
          ></header-disputa>
          <div v-show="!loadingPage && !loadingLote">
            <mensagem-box
              v-if="![6, 8].includes(dadosLeilao.statusmontagem_id)"
              ref="mensagem"
              :dadosLeilao="dadosLeilao"
              v-show="mostrarMesagem"
              :message="message"
              :liberado="liberado"
              :usuario="usuario"
            ></mensagem-box>
            <mensagem-box-leilao
              v-show="mostrarMesagem"
              :message_informativo="message_informativo"
              :informativo="informativo"
            ></mensagem-box-leilao>
          </div>

          <!-- Começo do lote aberto -->
          <div class="container__lote-aberto">
            <div v-if="leilao.nm_linkyoutube && isMobile">
              <VideoTransmissao :video-link="formataYoutubeLink(leilao.nm_linkyoutube)"/>
            </div>
            <!-- COMEÇO paginas, visitas, titulo, status-lote, titulo-lote, carousel e area lance -->
            <div class="content__lote-aberto">
              <div class="nulote-visitas-statuslote">
                <!-- Navegação Lotes Inicio -->
                <div class="tw-flex tw-gap-2 tw-items-center navegacao-visitas">
                  <!-- Bloco de Navegação -->
                  <div class="navegacao-lotes" v-if="isLoteInNavigation">
                    <!-- Link Anterior -->
                    <a
                      @click.prevent="navegarParaLote(navegacao.link_anterior)"
                      class="link-navegacao"
                    >
                      <i class="icon-arrow-prev tw-font-bold"></i>
                    </a>

                    <!-- Select -->
                    <select
                      v-model="loteId"
                      class="selecionar-lote"
                      title="selecionar lote"
                      @change="navegarParaLote(loteId)"
                    >
                      <option
                        class="tw-font-bold"
                        v-for="(opt, idx) in navegacao.lotes_combo"
                        :key="idx"
                        :value="opt.id"
                      >
                        Lote: {{ opt.nu < 10 ? '0' + opt.nu : opt.nu }}
                      </option>
                    </select>

                    <!-- Link Próximo -->
                    <a
                      @click.prevent="navegarParaLote(navegacao.link_proximo)"
                      class="link-navegacao"
                    >
                      <i class="icon-arrow-next tw-font-bold"></i>
                    </a>
                  </div>

                  <!-- Bloco Apenas com Número do Lote -->
                  <div v-else>
                    <div class="selecionar-lote">
                      <span>Lote:</span>
                      <span class="tw-font-bold">{{ lote.nu < 10 ? '0' + lote.nu : lote.nu }}</span>
                    </div>
                  </div>

                  <!-- Exibe as Visitas -->
                  <div class="nu-visitas">
                    <span>Visitas</span>
                    <span>{{ lote.nu_visitas ? lote.nu_visitas : 0 }}</span>
                  </div>
                </div>

                <div v-if="leilao.nm_linkyoutube && !isMobile">
                  <VideoTransmissao :video-link="formataYoutubeLink(leilao.nm_linkyoutube)"/>
                </div>

                <!-- Navegação Lotes Fim -->

                <span class="status-lote"
                      :class="statusLoteColor(statusLote.statuslote)"
                      v-if="!isMobile"
                >
                  {{ statusLote.statuslote }}
                </span>
              </div>
              <div class="esquerda-meio-direita">
                <div class="esquerda">
                  <div class="titulo__lote-aberto">
                    {{ lote.nm_titulo }}
                  </div>
                  <!-- Galeria de fotos lote -->
                  <div class="carousel-lote-aberto">
                    <carousel
                      ref="carousel"
                      class="content-imagem-visivel"
                      :dados="lote"
                      :visualizacao="visual"
                    />
                  </div>
                  <div v-if="lote.fotos && lote.fotos.length > 1" class="fotos-grid">
                    <div v-for="(foto, index) in lote.fotos" :key="index" class="foto-item">
                      <div @click="alteraFoto(index)">
                        <img alt="Foto do lote"
                             class="tw-rounded-lg tw-cursor-pointer"
                             :src="foto.nm_path_completo"
                        />
                      </div>
                    </div>
                  </div>

                  <div v-if="isTablet && !isMobile" class="bloco-extra tw-w-full tw-flex-col tw-gap-4">
                    <div
                      v-for="(vistoria, idv) in lote.vistoria"
                      :key="idv"
                    >
                      <span class="tw-font-bold tw-text-jrBlue-100">Anexos do lote</span>
                      <div class="lote-anexos-grid">
                        <div v-for="(anexo, ida) in vistoria.anexos" :key="ida"
                             class="anexo">
                          <a
                            :class="mainDomain !== 'meirelesleiloes' ? 'link-anexo-lote' : 'link-anexo-lote-meireles'"
                            title="Clique aqui para abrir o anexo"
                            target="_blank"
                            :href="`${anexo.nm_path_completo}`"
                          >
                            <span>{{ anexo.nm ? anexo.nm : 'Sem descrição' }}</span>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class="tw-rounded-lg tw-w-full">
                      <mensagem
                        :mensagens="mensagens"
                        :usuario="usuario"
                        :paramsite_chatcomprador="paramsite_chatcomprador"
                      ></mensagem>
                    </div>
                  </div>
                </div>

                <div class="content-lote-divider"></div>

                <div class="descricao-lote_area_lance">
                  <div class="titulo-descricao-lote">
                    <div class="descricao-max-content">
                      <span v-html="lote.nm_descricao" class="nm-descricao-lote"></span>
                    </div>
                  </div>

                  <div class="content-lote-divider"></div>

                  <div v-if="isMobile" class="tw-flex-col tw-gal-4">
                    <div
                      v-for="(vistoria, idv) in lote.vistoria"
                      :key="idv"
                    >
                      <span class="tw-font-bold tw-text-jrBlue-100">Anexos do lote</span>
                      <div class="lote-anexos-grid">
                        <div v-for="(anexo, ida) in vistoria.anexos" :key="ida"
                             class="anexo">
                          <a
                            :class="mainDomain !== 'meirelesleiloes' ? 'link-anexo-lote' : 'link-anexo-lote-meireles'"
                            title="Clique aqui para abrir o anexo"
                            target="_blank"
                            :href="`${anexo.nm_path_completo}`"
                          >
                            <span>{{ anexo.nm ? anexo.nm : 'Sem descrição' }}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="content-lote-divider" v-if="isMobile"></div>

                  <span class="status-lote"
                        :class="statusLoteColor(statusLote.statuslote)"
                        v-if="isMobile"
                  >
                  {{ statusLote.statuslote }}
                </span>

                  <area-lance
                    :lote="lote"
                    :key="loteId"
                    :historicoLances="historicoLances.length"
                    :leilao="leilao"
                    :lote_id_pregao="lote_id_pregao"
                    :usuario="usuario"
                    :liberado="liberado"
                    :isfavorito="isfavorito"
                    :lanceAtual="lanceAtual"
                    :statusLote="statusLote"
                    :dt_fechamento_lote="dt_fechamento_lote"
                    :liberacao_lote="liberacao_lote"
                    :paramsite_proposta="paramsite_proposta"
                    :preferencia="preferenciaLance"
                  />
                </div>
              </div>
            </div>
            <!-- FIM paginas, visitas, titulo, status-lote, titulo-lote, carousel e area lance -->

            <!-- Abas -->

            <!-- Anexos & Mensagens -->
            <div class="tw-w-full tw-flex tw-gap-4">
              <div
                v-for="(vistoria, idv) in lote.vistoria"
                :key="idv"
                class="tw-px-3 tw-bg-white tw-rounded-lg tw-w-1/2 tw-py-3"
                id="lote-anexos"
              >
                <span class="tw-font-bold tw-text-jrBlue-100">Anexos do lote</span>

                <!-- Envolve os anexos em uma div com classes de grade -->
                <div class="lote-anexos-grid">
                  <div
                    v-for="(anexo, ida) in vistoria.anexos"
                    :key="ida"
                    class="anexo"
                  >
                    <a
                      :class="mainDomain !== 'meirelesleiloes' ? 'link-anexo-lote' : 'link-anexo-lote-meireles'"
                      title="Clique aqui para abrir o anexo"
                      target="_blank"
                      :href="`${anexo.nm_path_completo}`"
                    >
                      <img
                        :src="getIconByFileType(anexo.nm_path_completo)"
                        alt="Ícone do Anexo"
                        class="icon-anexo"
                      />
                      <span>{{ anexo.nm ? anexo.nm : 'Sem descrição' }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="tw-px-3 tw-bg-white tw-rounded-lg tw-w-1/2 tw-py-3" id="lote-messages">
                <mensagem
                  :mensagens="mensagens"
                  :usuario="usuario"
                  :paramsite_chatcomprador="paramsite_chatcomprador"
                ></mensagem>
              </div>
            </div>

            <!-- Histórico lances -->
            <div
              class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-text-jrBlue-100 tw-bg-white tw-rounded-md tabs-info">
              <div v-if="historicoLances.length > 0"
                   :class="!isMobile ? 'tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-py-3' : 'tw-text-[12px] tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-py-3'">
                <span class="tw-font-bold">Histórico de Lances</span>
                <div class="tw-text-semibold">
                  <span>Quantidade total de lances:</span>
                  <span
                    :class="!isMobile ? 'tw-px-3 tw-bg-jrBlue-100 tw-text-white tw-rounded': 'tw-px-1 tw-bg-jrBlue-100 tw-text-white tw-rounded'">
                    {{ historicoLances.length }}
                  </span>
                </div>
              </div>

              <div
                v-if="historicoLances.length > 0"
                class="tw-px-3 tw-mb-3 tw-relative tw-overflow-x-auto"
              >
                <table
                  class="tw-w-full tw-text-sm tw-text-center rtl:tw-text-right tw-text-gray-500 tw-shadow tw-font-poppins">
                  <thead
                    class="tw-flex tw-text-xs tw-text-white tw-uppercase tw-bg-jrBlue-25 tw-w-full tw-py-1">
                  <tr class="tw-flex tw-w-full tw-justify-between">
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[115px] tw-text-[12px]'">
                      Data
                    </th>
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[115px] tw-text-[12px]'">
                      Hora
                    </th>
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[115px] tw-text-[12px]'">
                      Usuário
                    </th>
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[115px] tw-text-[12px]'">
                      Lance (R$)
                    </th>
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[90px] tw-text-[12px]'">
                      Forma Pgto.
                    </th>
                    <th scope="col" :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[90px] tw-text-[12px]'"
                        v-if="lote.nu_intervaloparcelaslote == 5">
                      Entrada (%)
                    </th>
                    <th v-if="temPreferencial"
                        scope="col"
                        :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[90px] tw-text-[12px]'"
                    >
                      Preferência
                    </th>
                    <th v-if="totallancesAutomaticos > 0"
                        scope="col"
                        :class="!isMobile ? 'tw-w-full tw-px-6 tw-py-3' : 'tw-w-[90px] tw-text-[12px]'"></th>
                  </tr>
                  </thead>
                  <tbody
                    class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-w-full tw-h-44 tw-overflow-y-auto">
                  <tr
                    v-for="(historico, idx) in historicoLances"
                    :key="idx"
                    class="tw-flex tw-w-full tw-bg-white tw-border-b"
                  >
                    <!-- Data -->
                    <td :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[115px] tw-py-2 tw-text-[12px]'">
                      {{ historico.data_formatada }}
                    </td>
                    <!-- Hora -->
                    <td :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[115px] tw-py-2 tw-text-[12px]'">
                      {{ historico.hora_formatada }}
                    </td>
                    <!-- Usuário -->
                    <td :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[115px] tw-py-2 tw-text-[12px]'">
                      {{ historico.nm_apelido }}
                    </td>
                    <!-- Lance -->
                    <td :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[115px] tw-py-2 tw-text-[12px]'">
                      {{ $root.formatarPreco(historico.vl) }}
                    </td>
                    <!-- Forma de pagamento -->
                    <td v-if="historico.nu_parcelas > 0"
                        :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[90px] tw-py-2 tw-text-[12px]'">
                      {{
                        historico.nu_parcelas === 1 ||
                        !historico.nu_parcelas
                          ? "à vista"
                          : historico.nu_parcelas + "x"
                      }}
                    </td>
                    <!-- Percentual de entrada -->
                    <td v-if="lote.nu_intervaloparcelaslote == 5"
                        :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[90px] tw-py-2 tw-text-[12px]'">
                      {{ historico.vl_percentualentrada == 0 ? '--' : historico.vl_percentualentrada }}
                    </td>
                    <!-- Usuário com preferência -->
                    <td v-if="temPreferencial"
                        :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[90px] tw-py-2 tw-text-[12px]'">
                      {{ historico.nm_apelido_preferencia === true ? "Sim" : "Não" }}
                    </td>
                    <!-- Lance automático -->
                    <td v-if="totallancesAutomaticos > 0" :class="!isMobile ? 'tw-w-full tw-py-4' : 'tw-w-[90px] tw-py-2 tw-text-[12px]'">
                      {{ historico.bn_automatico == 1 ? "(A)" : "" }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="tw-p-3">
                <span class="tw-font-bold tw-text-jrBlue-100">Histórico de lances</span>
              </div>
            </div>

            <div v-if="isMobile"
                 class="tw-px-3 tw-flex tw-bg-white tw-rounded-lg tw-w-full tw-py-3" id="lote-messages">
              <mensagem
                :mensagens="mensagens"
                :usuario="usuario"
                :paramsite_chatcomprador="paramsite_chatcomprador"
              ></mensagem>
            </div>

            <div class="tw-w-full tw-flex tw-gap-4 tw-text-jrBlue-100">
              <!-- Localização -->
              <div
                v-if="mostrarBtn"
                class="tw-w-full tw-text-jrBlue-100 tw-bg-white tw-rounded-md tabs-info">
                <div v-if="lote.vistoria" class="tw-flex tw-flex-col tw-gap-4">
                  <span class="tw-px-3 tw-py-3 tw-font-bold">Localização:</span>
                  <div class="tw-px-3 tw-py-3">
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${lote.vistoria[0].i_nu_latitude},${lote.vistoria[0].i_nu_longitude}`"
                      class="hover:tw-font-semibold"
                      target="_blank"
                    >Clique para ver no mapa</a>
                  </div>
                </div>
                <div v-else class="tw-px-3 tw-py-3">
                  <span class="tw-font-semibold">Localização não disponível para este item</span>
                </div>
              </div>

              <!-- Judicial -->
              <div
                class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-text-jrBlue-100 tw-bg-white tw-rounded-md tabs-info"
                v-if="lote.judicial && lote.judicial.nu_processo !== ''"
              >
                <span class="tw-p-3 tw-font-bold tw-text-jrBlue-100">Processo Judicial</span>
                <div v-if="lote.judicial" class="tw-px-8 tw-py-3">
                  <h2>Processo: {{ lote.judicial.nu_processo }}</h2>
                  <div>
                    <p v-if="lote.judicial.nm_acao">
                      <strong>Ação:</strong>
                      <span>{{ lote.judicial.nm_acao }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_autor">
                      <strong>Autor:</strong>
                      <span>{{ lote.judicial.nm_autor }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_reu">
                      <strong>Réu:</strong>
                      <span>{{ lote.judicial.nm_reu }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_exequente">
                      <strong>Exequente:</strong>
                      <span>{{ lote.judicial.nm_exequente }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_executada">
                      <strong>Executada:</strong>
                      <span>{{ lote.judicial.nm_executada }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_juiz">
                      <strong>Juíz:</strong>
                      <span>{{ lote.judicial.nm_juiz }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_edital">
                      <strong>Edital:</strong>
                      <span>{{ lote.judicial.nm_edital }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_doe">
                      <strong>DOE:</strong>
                      <span>{{ lote.judicial.nm_doe }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_publicacao">
                      <strong>Publicação:</strong>
                      <span>{{ lote.judicial.nm_publicacao }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_vara">
                      <strong>Vara:</strong>
                      <span>{{ lote.judicial.nm_vara }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_praca">
                      <strong>Leilão:</strong>
                      <span>{{ lote.judicial.nm_praca }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_municipio">
                      <strong>Município:</strong>
                      <span>{{ lote.judicial.nm_municipio }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_comarca">
                      <strong>Comarca:</strong>
                      <span>{{ lote.judicial.nm_comarca }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_porcentagem">
                      <strong>Porcentagem:</strong>
                      <span>{{ lote.judicial.nm_porcentagem }}</span>
                    </p>
                    <p v-if="lote.judicial.nu_hasta">
                      <strong>Nº Hasta:</strong>
                      <span>{{ lote.judicial.nu_hasta }}</span>
                    </p>
                    <p v-if="lote.judicial.nm_observacao">
                      <strong>Observação:</strong>
                      <span v-html="lote.judicial.nm_observacao"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="tw-flex tw-gap-4 lotes-repasse-retirado">
              <!-- Lotes Repasse -->
              <div v-if="lotesRepasse.length > 0"
                   class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-text-jrBlue-100 tw-bg-white tw-rounded-lg">
                <div class="tw-px-3 tw-py-3 tw-flex tw-justify-between lg:tw-text-sm lotes-repasse-lance">
                  <span class="tw-font-semibold">Lotes em repasse:</span>
                  <div>
                    <span><i class="repasse_i"></i>Repasse</span>
                    <span><i class="repasse__lance_i"></i>Repasse com lance</span>
                  </div>
                </div>
                <div class="tw-px-1 tw-py-4">
                  <div id="lotes_repasse" v-if="lotesRepasse.length > 0">
                    <div
                      v-for="(repasse, lote_id) in lotesRepasse"
                      :key="lote_id"
                      class="tw-p-2"
                    >
                      <router-link
                        :to="'/leilao/index/leilao_id/' + leilaoId + '/lote/' + repasse.id"
                        class="tw-flex tw-w-max-content"
                      >
                        <span :class="getStatusColor(repasse.statuslote_id)">Lote: {{ repasse.nu }}</span>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <span class="tw-ml-2">Nenhum lote em repasse</span>
                  </div>
                </div>
              </div>

              <!-- Lotes Retirados -->
              <div v-if="lotesRetirados.length > 0"
                   class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-text-jrBlue-100 tw-bg-white tw-rounded-lg">
                <div class="tw-px-3 tw-py-3 tw-flex tw-justify-between lg:tw-text-sm">
                  <span class="tw-font-semibold">Lotes retirados:</span>
                  <div>
                    <span><i class="retirado_i"></i>Retirado</span>
                    <span><i class="cancelado_i"></i>Cancelado</span>
                    <span><i class="excluido_i"></i>Excluído</span>
                  </div>
                </div>
                <div class="tw-px-1 tw-py-4">
                  <div id="lotes_retirados"
                       v-if="lotesRetirados.length > 0">
                    <div class="tw-p-2" v-for="(rt, lote_id) in lotesRetirados" :key="lote_id">
                      <router-link
                        :to="'/leilao/index/leilao_id/' + leilaoId + '/lote/' + rt.id"
                        class="tw-flex tw-w-max-content"
                      >
                        <span :class="getStatusColor(rt.statuslote_id)">Lote: {{ rt.nu }}</span>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <span class="tw-ml-2">Nenhum lote retirado</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <ModalHAbilitacaoExtra ref="modalHabilitacao" :info="info"/>
    <CondicoesVenda ref="modalCondicoes" :leilao="leilao"/>
    <!-- Id leilao.id referente ao alerta no v-show no modalalertas -->
    <ModalAlertas ref="modalAlertas" v-show="leilao.id == 10198"/>
  </div>
</template>

<script>
import {Stretch} from "vue-loading-spinner";
import ThumbSlide from "@/components/thumbSlide/ThumbSlide";
import Countdown from "@/components/shared/Countdown.vue";

//LAYOUT COMPONENT
import BreadCrumb from "@/components/shared/BreadCrumb";
import AreaLance from "@/components/shared/AreaLance";
import BotoesRotas from "@/components/shared/BotoesRotas";
import NaoEncontrado from "@/components/shared/NaoEncontrado";
import HeaderDisputa from "@/components/shared/HeaderDisputa";
import MensagemBox from "@/components/shared/MensagemBox";
import MensagemBoxLeilao from "@/components/shared/MensagemBoxLeilao";
import Mensagem from "@/components/shared/Mensagem";
import {Tab, Tabs} from "vue-tabs-component";
import SeguirLeiloeiro from "@/components/shared/SeguirLeiloeiro";
import Loading from "./shared/Loading.vue";
import Carousel from "./shared/Carousel.vue";
import CondicoesVenda from "./shared/CondicoesVenda.vue";
import VideoTransmissao from "@/components/shared/social/VideoTransmissao";

import Vue from 'vue'
import VueImg from 'v-img'
import ModalHAbilitacaoExtra from "./shared/ModalHAbilitacaoExtra.vue";
import ModalAlertas from "./shared/ModalAlertas.vue";

Vue.use(VueImg)

let interval = null;

export default {
  props: ["dadosLeilao", "dadosModeradorId"],
  components: {
    VideoTransmissao,
    ModalAlertas,
    ModalHAbilitacaoExtra,
    CondicoesVenda,
    Loading,
    AreaLance,
    Countdown,
    BreadCrumb,
    Stretch,
    NaoEncontrado,
    BotoesRotas,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao,
    Mensagem,
    SeguirLeiloeiro,
    Tabs,
    ThumbSlide,
    Tab,
    Carousel
  },
  data() {
    return {
      leilao: [],
      lote: [],
      lotesGerais: [],
      dados_condicao: [],
      usuario: [],
      config_leiloeiro: [],
      navegacao: {
        link_anterior: null,
        link_proximo: null,
        lotes_combo: []
      },
      historicoLances: [],
      thisHeaderDisputa: null,
      statusLote: {
        statuslote: "status",
        statusLoteBg: "",
        statuslote_id: -1,
        statusliberacaolote_id: ""
      },
      dadosRequisicao: {isLogado: false},
      lotesRepasse: [],
      lotesRetirados: [],
      mensagens: [],
      paramsite_chatcomprador: [],
      paramsite_comitente: [],
      paramsite: [],
      paramsite_proposta: [],
      lanceAtual: {
        vl_lance: 0.0,
        nm_apelido: null,
        vl_lance_sugerido: 0.0,
        nu_parcelas: 1,
        vl_percentualentrada: 0.0
      },
      leilaoId: this.$route.params.id,
      loteId: this.$route.params.idlote,
      linkCombo: this.$route.params.idlote,
      cookie: false,
      loadingPage: true,
      loadingLote: true,
      naoEncontradoLoteAberto: false,
      refreshCountLoteAberto: 30000,
      errors: [],
      message: "",
      liberado: false,
      message_informativo: "",
      informativo: false,
      fechamento: false,
      isfavorito: false,
      index: 0,
      slides: [],
      vistorias: [],
      saladisputa: null,
      refLanceAtual: null,
      refStatus: null,
      refMensagens: null,
      refIncremento: null,
      dt_fechamento_lote: 0,
      liberacao_lote: true,
      countLote: null,
      /*seguir leiloeiro*/
      firstLoadSalaDisputa: true,
      lote_id_pregao: -1,
      seguir: false,
      visual: 'loteAberto',
      mostrarMesagem: false,
      mostrarBtn: false,
      info: '',
      screenWidth: window.innerWidth,
      preferencia: [],
      preferenciaLance: false,
    };
  },
  computed: {
    totallancesAutomaticos() {
      return this.historicoLances.filter(lance => lance.bn_automatico === true || lance.bn_automatico === 1).length;
    },
    isLoteInNavigation() {
      return this.navegacao.lotes_combo && this.navegacao.lotes_combo.length > 1;
    },
    titulo() {
      if (this.leilao.nm)
        return this.leilao.nm.split('|')[0]

      return ''
    },
    isTablet() {
      return this.screenWidth <= 768;
    },
    isMobile() {
      return this.screenWidth <= 435;
    },
    mainDomain() {
      const domainParts = window.location.hostname.split('.');
      return domainParts.length > 2 ? domainParts[1] : domainParts[0];
    },
    temPreferencial() {
      return this.historicoLances.some(h => h.nm_apelido_preferencia === true);
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    navegarParaLote(id) {
      if (id !== this.$route.params.idlote) {
        this.$router.push({
          name: 'LoteAberto',
          params: {id: this.leilaoId, idlote: id}
        }).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Erro na navegação:", err);
          }
        });
        this.atualizarLinksNavegacao(id);
      }
    },
    atualizarLinksNavegacao(loteAtualId) {
      const index = this.navegacao.lotes_combo.findIndex(lote => lote.id === loteAtualId);

      if (index !== -1) {
        this.navegacao.link_anterior = index > 0 ? this.navegacao.lotes_combo[index - 1].id : null;
        this.navegacao.link_proximo = index < this.navegacao.lotes_combo.length - 1 ? this.navegacao.lotes_combo[index + 1].id : null;
      } else {
        this.navegacao.link_anterior = null;
        this.navegacao.link_proximo = null;
      }

      this.loteId = loteAtualId;
    },
    scrollToLoteAberto() {
      setTimeout(() => {
        const loteAberto = document.querySelector('.content__lote-aberto');
        if (loteAberto) {
          loteAberto.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }, 300);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    modalHabilitacao(descricao) {
      this.info = descricao;
      this.$refs.modalHabilitacao.modalToggle();
    },
    getIconByFileType(fileName) {
      if (!fileName) return '/icons/unknown.svg';

      const extension = fileName.split('.').pop().toLowerCase();

      const icons_path = this.lote && this.lote.vistoria[0].anexos[0].nm_path_incompleto
        ? `${this.lote.vistoria[0].anexos[0].nm_path_incompleto}/jrleiloes/layout/icons`
        : '/icons';

      const icons = {
        pdf: `${icons_path}/pdf.svg`,
        doc: `${icons_path}/doc.svg`,
        docx: `${icons_path}/doc.svg`,
        xls: `${icons_path}/doc.svg`,
        xlsx: `${icons_path}/doc.svg`,
        png: `${icons_path}/image.svg`,
        svg: `${icons_path}/image.svg`,
        jpg: `${icons_path}/image.svg`,
        jpeg: `${icons_path}/image.svg`,
        txt: `${icons_path}/doc.svg`,
        default: `${icons_path}/unknown.svg`,
      };

      return icons[extension] || icons.default;
    },
    getStatusColor(statuslote_id) {
      switch (statuslote_id) {
        case 6:
          return "tw-text-white tw-bg-jrGreen-200 tw-p-2 tw-rounded";
        case 10:
          return "tw-text-white tw-bg-jrRed-100 tw-p-2 tw-rounded";
        case 11:
          return "tw-text-white tw-bg-jrBlue-200 tw-p-2 tw-rounded";
        case 13:
          return "tw-text-white tw-bg-jrOrange-100 tw-p-2 tw-rounded";
        case 15:
          return "tw-text-white tw-bg-jrWater-100 tw-p-2 tw-rounded";
        default:
          return "tw-bg-white";
      }
    },
    statusLoteColor(statuslote) {
      switch (statuslote) {
        case "Aberto para Lance":
          return "tw-bg-jrGreen-new tw-text-white tw-font-bold";
        case "Em Pregão":
          return "tw-bg-jrGreen-new-50 tw-text-white tw-font-bold";
        case "Dou-lhe Duas":
          return "tw-bg-jrYellow-new tw-text-white tw-font-bold";
        case "Dou-lhe Uma":
          return "tw-bg-jrOrange-new tw-text-white tw-font-bold";
        case "Vendido":
          return "tw-bg-jrWater-100 tw-text-white tw-font-bold";
        case "Condicional":
          return "tw-bg-jrGray-300 tw-text-white tw-font-bold";
        case "Repasse":
          return "tw-text-white tw-bg-jrGreen-200";
        case "Não Vendido":
          return "tw-bg-jrRed-new tw-text-white tw-font-bold";
        case "Não Homologado":
          return "tw-bg-jrGray-100";
        case "Homologado":
          return "tw-text-white tw-bg-jrBlue-100";
        case "Retirado":
          return "tw-text-white tw-bg-jrRed-100";
        case "Repasse com Lance":
          return "tw-text-white tw-bg-jrBlue-200";
        case "Cancelado":
          return "tw-text-white tw-bg-jrRed-100";
        case "Dou-lhe Três":
          return "tw-bg-white";
        case "Excluido":
          return "tw-text-white tw-bg-jrRed-100";
        case "Arrematado Sub Judice":
          return "tw-bg-jrGray-300 tw-text-white tw-font-bold";
        case "Fechado":
          return "tw-bg-jrGray-300 tw-text-white tw-font-bold";
        case "Sub Judice":
          return "tw-bg-jrGray-300 tw-text-white tw-font-bold";
        case "Aguardando":
          return "tw-bg-jrGray-300 tw-text-white tw-font-bold";
        case "Arrematado Não Pago":
          return "tw-bg-jrBlue-new tw-text-white tw-font-bold";
        case "Adiado":
          return "tw-text-white tw-bg-jrRed-100";
        default:
          return "tw-bg-white";
      }
    },
    openModalCondicoes() {
      this.$refs.modalCondicoes.modalToggle()
    },
    alteraFoto(item) {
      if (!this.$refs.carousel.carouselItem) {
        this.$refs.carousel.carousel();
      }
      this.$refs.carousel.slideTo(item);
    },
    formataLinkVideo(link) {
      if (link.search("youtube") > 0) {
        this.tipo_video = "youtube";
        return link.replace(/(.*?=)([\w-]+)&?(.*?)?$/g, "$2") + "?autoplay=1;";
      } else if (link.search("vimeo") > 0) {
        this.tipo_video = "vimeo";
        return link.replace(/(.*?)([\d]+)$/g, "$2");
      }
    },
    formataYoutubeLink(link) {
      if (link) {
        return `https://www.youtube.com/watch?v=${link}`;
      }
      return '';
    },
    clickItem(i) {
      this.index = i;
    },
    loteClicado(id) {
      if (id !== this.$route.params.idlote) {
        this.$router.push({name: 'LoteAberto', params: {id: this.leilaoId, idlote: id}});
      }
      this.loteId = id;
      this.linkCombo = id;

      this.historicoLances = [];

      sessionStorage.setItem("loteId", id);
      this.$parent.$emit("statusloteClicado", true);
      this.$parent.$emit("loteIdAtualChange", id);
      this.acompanhaLotePregao();
    },
    callInfoAfterRoute(leilaoid, loteid) {
      this.leilaoId = leilaoid;
      this.loteId = loteid;
      this.refIncremento = null;
      this.atualizarLinksNavegacao(loteid);

      this.acompanhaHistoricoLances();
      this.acompanhaMensagens();
      this.acompanhaStatus();
      this.refreshDadosGerais(this);
      this.refreshLote();
      this.acompanhaLotePregao();
    },
    acompanhaLanceAtual() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refLanceAtual != null) {
        this.refLanceAtual.off();
        this.lanceAtual.vl_lance = 0.0;
        this.lanceAtual.nm_apelido = null;
        this.lanceAtual.vl_lance_sugerido = 0.0;
        this.lanceAtual.nu_parcelas = 1;
        this.lanceAtual.vl_percentualentrada = 0.0;
      }

      this.refLanceAtual = db.ref(`/lance/${this.leilaoId}/${this.loteId}`);
      this.refLanceAtual.once("value", function (data) {
        if (data.val() == null) {
          // nenhum lance
          if (!self.refIncremento) {
            self.acompanhaIncremento();
          }
        }
      });

      this.refLanceAtual
        .orderByChild("id")
        .limitToLast(1)
        .on("child_added", function (data) {
          self.lanceAtual.vl_lance = data.val().vl;
          self.lanceAtual.nm_apelido = data.val().nm_apelido;
          self.lanceAtual.nu_parcelas = data.val().nu_parcelas;
          self.lanceAtual.vl_lance_sugerido =
            parseFloat(data.val().vl) + parseFloat(self.lote.raw_incremento);
          self.lanceAtual.vl_percentualentrada = data.val().vl_percentualentrada;

          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(self.lanceAtual.vl_lance_sugerido);

          self.acompanhaHistoricoLances();
          if (!self.refIncremento) {
            self.acompanhaIncremento();
          }
        });

      this.refLanceAtual.on("child_removed", function (data) {
        self.refLanceAtual.once("value", function (snapshot) {
          if (!snapshot.exists()) {
            self.lanceAtual.vl_lance = 0.0;
            self.lanceAtual.nm_apelido = null;
            self.lanceAtual.vl_lance_sugerido = 0.0;
            self.lanceAtual.nu_parcelas = 1;
            self.acompanhaIncremento();
            self.acompanhaHistoricoLances();
          }
        });
      });
    },

    acompanhaHistoricoLances() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      function addHours(numOfHours, date = new Date()) {
        date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
        return date;
      }

      this.historicoLances = [];
      db.ref(`/lance/${this.leilaoId}/${this.loteId}`)
        .orderByChild("id")
        .once("value")
        .then(function (data) {
          if (data.val()) {
            var registros = Object.values(data.val());

            registros.forEach(function (reg) {
              const dt_split = reg.data_formatada.split("/");
              const dt_formatada = dt_split[2] + "-" + dt_split[1] + "-" + dt_split[0];
              const date = new Date(dt_formatada + 'T' + reg.hora_formatada);

              if (self.leilao.statusfusohorario_id) {
                const dt = addHours(self.leilao.statusfusohorario_id, date);
                reg.hora_formatada = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2) + ":" + ("0" + dt.getSeconds()).slice(-2);
              }

              var preferencia = window.localStorage.getItem('a5cc51388b67c5c132389a6ffc950dbf');
              reg.nm_apelido_preferencia = false;

              if (preferencia.includes(reg.nm_usuario_id)) {
                reg.nm_apelido_preferencia = true;
              }
              self.historicoLances.unshift(reg);
            });
          }
        });
    },

    acompanhaStatus() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refStatus != null) {
        this.refStatus.off();
      }

      this.refStatus = db.ref(`/status/${this.leilaoId}/${this.loteId}`);
      this.refStatus.on("value", function (data) {
        self.statusLote.statuslote = data.val().statuslote;
        self.statusLote.statusLoteBg = data.val().statusLoteBg;
        self.statusLote.statusliberacaolote_id = data.val().statusliberacaolote_id;
        self.liberacao_lote = true;

        if (self.statusLote.statusliberacaolote_id != undefined) {
          if (self.statusLote.statusliberacaolote_id != 2) {
            self.liberacao_lote = false;
          }
        }
      });
    },

    acompanhaIncremento() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refIncremento != null) {
        this.refIncremento.off();
      }
      this.refIncremento = db.ref(
        `/incremento/${this.leilaoId}/${this.loteId}`
      );
      this.refIncremento.on("value", function (data) {
        self.lote.raw_incremento = data.val().raw_incremento;
        var lancesuregido = 0;

        //Novo: Verifcando se existe lance no nó de lance do firebase e nao no nó de lote onde nao está sendo atualizado o valor do ultimo lance em realtime.
        if (self.lanceAtual.vl_lance > 0) {
          //Lote com lance
          lancesuregido =
            parseFloat(self.lanceAtual.vl_lance) +
            parseFloat(self.lote.raw_incremento);
        } else {
          //Sem lance
          if (self.lote.vl_lanceinicial <= 0) {
            lancesuregido = parseFloat(self.lote.raw_incremento);
          } else {
            lancesuregido = parseFloat(self.lote.vl_lanceinicial);
          }
        }

        self.lanceAtual.vl_lance_sugerido = lancesuregido;
        if (self.leilao.statusleilao_id == 13) {
          //Venda direta precisa retirar o R$
          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(lancesuregido).replace("R$ ", "");
        } else {
          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(lancesuregido);
        }
      });
    },

    acompanhaMensagens() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      function addHours(numOfHours, date = new Date()) {
        date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
        return date;
      }

      if (this.refMensagens != null) {
        this.refMensagens.off();
      }

      this.mensagens = [];
      this.refMensagens = db.ref(`/mensagem/${this.leilaoId}/${this.loteId}`);
      this.refMensagens.on("child_added", function (datas) {
        $("[aria-controls='#mensagens']").addClass("fa-blink");

        const reg = datas.val();
        const date = new Date();
        date.setHours(reg.data.split(":")[0], reg.data.split(":")[1], reg.data.split(":")[2]);

        if (!!self.leilao.statusfusohorario_id) {
          const dt = addHours(self.leilao.statusfusohorario_id, date);
          reg.data = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2) + ":" + ("0" + dt.getSeconds()).slice(-2);
        }

        self.mensagens.push(reg);
      });

      this.refMensagens.on("child_removed", function (data) {
        var idx = self.mensagens.findIndex(m => (m.id = data.id));
        self.mensagens.splice(idx, 1);
      });
    },

    acompanhaRepasse() {
      var self = this;
      self.lotesRepasse = [];

      for (let i in self.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 11 || statusLoteId === 6) {
          let loteRepasse = {...self.lotesGerais[i], statuslote_id: statusLoteId};
          self.lotesRepasse.push(loteRepasse);
        }
      }
    },

    acompanhaRetirado() {
      const self = this;
      this.lotesRetirados = [];

      for (let i in this.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 15 || statusLoteId === 13 || statusLoteId === 10) {
          let loteRetirado = {...this.lotesGerais[i], statuslote_id: statusLoteId};
          this.lotesRetirados.push(loteRetirado);
        }
      }
    },

    async refreshDadosGeraisHeader() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;
      this.preferenciaLance = false;

      await fetch(`${hostName}/leilao/get-dados-header-disputa?leilao_id=${this.leilaoId}&lote_id=${this.loteId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          self.lotesGerais = res.navegacao.lotes_gerais

          if (self.lotesGerais) {
            self.acompanhaRepasse()
            self.acompanhaRetirado()
          }

          self.preferencia = res.usuario_preferencia || [];

          if (Array.isArray(self.preferencia) && self.usuario && self.usuario.id) {
            self.preferenciaLance = self.preferencia.includes(self.usuario.id);
          }
        })
        .catch(e => {
          console.error('Erro ao buscar dados do header:', e);
        });
    },

    refreshDadosGerais(childSelf) {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;

      // lanceautomatico e usuario (favorito)
      fetch(
        `${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}&lote_id=${this.loteId}`
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          this.lote.vl_lanceautomatico = res.vl_lanceautomatico;
          this.usuario = res.usuario;
          this.dadosRequisicao.isLogado =
            this.usuario.id !== null ? true : false;

          if (this.lote.vl_lanceautomatico > 0) {
            this.lote.vl_lanceautomatico = self.$root.formatarPreco(
              this.lote.vl_lanceautomatico
            );
          }

          this.navegacao = res.navegacao;
          this.isfavorito = res.usuario.is_favorito;
        });
    },

    refreshLote() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      db.ref(`/lote/${this.leilaoId}/${this.loteId}`).once("value", function (
        data
      ) {
        self.lote = data.val();
        self.acompanhaLanceAtual();
        self.mostrarBtn = (self.lote.vistoria[0]['id_segmento'] === 3 && self.lote.vistoria.some(item => item['i_nu_latitude'])) ? true : false;
        //slides
        self.slides = [];
        if (self.lote.fotos != undefined) {
          self.lote.fotos.map((item, idx) => {
            self.slides.push({
              id: idx,
              big: `${item.nm_path_incompleto}${item.tamanho.thumb_grande}/${item.nm_path}`,
              thumb: `${item.nm_path_incompleto}${item.tamanho.thumb}/${item.nm_path}`
            });
          });
        }

        self.loadingPage = false;
        self.loadingLote = false;
      });

      //Atualiza cronometro do lote aberto;
      db.ref(`/dtfechamento/${this.leilaoId}/${this.loteId}`).on(
        "value",
        function (data) {
          if (data.val()) {
            self.fechamento = data.val();
            self.dt_fechamento_lote = self.fechamento.dt_fechamento;
          } else {
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            self.dt_fechamento_lote = date + ' ' + time;
          }
        }
      );
    },

    acompanhaLotePregao() {
      const self = this;

      var db = this.firebase_db;

      if (self.seguir) {
        self.acompanhaHistoricoLances();
      }

      if (self.lote_id_pregao > 0 && self.seguir) {
        db.ref(`/lote/${self.leilaoId}/${self.lote_id_pregao}`).once("value", function (data) {
          self.lote_pregao = data.val();
        })
      }
    },

    seguirLeiloeiro(ev) {
      this.seguir = !this.seguir;
      if (!this.leilao.bn_fechamentoautomatico) {
        if (this.seguir) {
          this.loteClicado(this.leilao.statuslotemoderador_id);
        }
      }
      this.acompanhaLotePregao();
    },
  },

  created() {
    this.leilao = this.dadosLeilao
    this.statusModerador = this.dadosModeradorId

    this.saladisputa = new window.saladisputa(this);
    clearInterval(window.INTERVALO_BUSCA);
    clearInterval(window.INTERVALO_CATEGORIA);

    const self = this;

    this.refreshLote(); // acompanha lote
    this.acompanhaMensagens(); // acompanha chat
    this.acompanhaStatus(); // acompanha status
    this.acompanhaLotePregao(); //acompanha lote em pregão
    this.refreshDadosGeraisHeader();
    // this.acompanhaHistoricoLances(); //acompanha historicos

    // registra visita
    const hostName = location.protocol + "//" + window.HOSTNAME;
    fetch(`${hostName}/leilao/salva-visita/lote_id/${this.loteId}`);

    this.$on("dados-gerais", function (data) {
      this.config_leiloeiro = data.config_leiloeiro;
      this.dados_condicao = data.dados_condicao;
      this.usuario = data.usuario;
      this.isfavorito = data.usuario.is_favorito;
      this.lote.vl_lanceautomatico = data.vl_lanceautomatico;
      this.navegacao = data.navegacao;
      this.thisHeaderDisputa = data.thisHeaderDisputa;
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false;

      if (this.lote.vl_lanceautomatico > 0) {
        this.lote.vl_lanceautomatico = self.$root.formatarPreco(
          this.lote.vl_lanceautomatico
        );
      }

      // CONFIG AUTO RELOAD
      if (this.usuario.id !== null) {
        sessionStorage.setItem(
          "isLogado",
          this.usuario.id !== null ? true : false
        );
      }
    });

    this.$on("callDadosGerais", function () {
      self.refreshDadosGerais();
    });

    this.$on("liberacaoMensagem", function (json) {
      //console.log('2: ', json)
      this.message = json.message;
      this.liberado = json.liberado;
      this.fechamento = json.fechamento; // leilao.bn_fechamentoautomatico
      this.message_informativo = json.message_informativo;
      this.informativo = json.informativo;
      this.mostrarMesagem = json.mostrarMesagem
    });

    this.$on("addFavorito", function (data) {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const self = this;

      let urlRequest = this.isfavorito ? "exclui-favorito" : "add-favorito";

      this.isfavorito = !this.isfavorito;

      fetch(`${hostName}/leilao/${urlRequest}?lote_id=${this.lote.lote_id}&usuario_id=${this.usuario.id}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(function (response) {
          self.refreshDadosGerais(self);
        })
        .catch(function (error) {
          alert("Erro inesperado");
          console.log(error);
        });
    });

    //verifica cookie e browser
    this.cookie = this.$root.cookieAtivo;
    this.$root.MensagemBrowserCookie();


    var db = this.firebase_db;

    //Nó paramsite do firebase
    db.ref(`/paramsite/`).once("value", function (data) {
      $.each(data.val(), function (key, value) {
        //Chat comprador
        if (value && value.statusparamsite_id == 71) {
          self.paramsite_chatcomprador = value;
        }
        //Exibição de comitente na vistoria
        if (value && value.statusparamsite_id == 72) {
          self.paramsite_comitente = value;
        }
        //Alteração de label de venda direta para proposta
        if (value && value.statusparamsite_id == 74) {
          self.paramsite_proposta = value;
        }
      });
    });
  },

  beforeUpdate() {

    setTimeout(() => {
      if (this.$refs.titleLength) {
        if (this.$refs.titleLength.innerHTML.length > 40) {
          this.$refs.titleLength.setAttribute(
            "style",
            "font-size:20px !important"
          );
        }
      }

      if (this.$refs.precoLength) {
        const len = this.$refs.precoLength.innerHTML.length;

        if (len > 13 && len <= 16) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:30px !important"
          );
        } else if (len > 16 && len <= 18) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:28px !important"
          );
        } else if (len > 18) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:22px !important"
          );
        }
      }
    }, 500);
  },
  watch: {
    'lote.fotos': {
      handler(novasFotos) {
        if (novasFotos && novasFotos.length > 1) {
          this.$refs.carousel.carousel();
        }
      },
      deep: true,
    },
    '$route.params.idlote': {
      immediate: true,
      handler(newIdLote) {
        this.loteId = newIdLote;
        this.atualizarLinksNavegacao(newIdLote);
        this.scrollToLoteAberto();
      }
    },
    $route(to, from) {
      this.callInfoAfterRoute(this.$route.params.id, this.$route.params.idlote);
    },
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    },
    linkCombo: {
      handler(novoObj, antigoObj) {
        this.$emit("statusloteClicado", true);
        this.$router.replace({params: {idlote: novoObj}});
      }
    },
    'statusLote.statuslote'(novo, antigo) {
      this.refreshDadosGeraisHeader()
    },
    'lanceAtual.vl_lance'(novo, antigo) {
      this.refreshDadosGeraisHeader()
    },
    'dadosModeradorId'(novo, ant) {
      this.statusModerador = this.dadosModeradorId
      this.lote_id_pregao = novo.items[0].statuslotemoderador_id
      if (this.seguir) {
        this.loteClicado(this.lote_id_pregao);
      }
    },
    "preferencia"() {
      this.preferencia = this.preferencia;
      this.acompanhaHistoricoLances();
    }
  }
};
</script>
<style>
.container__lote-aberto {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 0.375rem;
  gap: 1rem;
}

.content__lote-aberto {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 15px;
  gap: 1rem;
  padding: 1rem;
}

.titulo__lote-aberto {
  font-family: New Order, sans-serif !important;
  font-weight: 700;
  font-size: 24px;
  color: #1c2d47;
}

.nulote-visitas-statuslote {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nu-visitas {
  display: flex;
  font-size: 15px;
  color: #1c2d47;
  gap: 5px;
  font-weight: 500;
}

.status-lote {
  font-size: 15px;
  padding: 5px 11px;
  border-radius: 4px;
  text-transform: lowercase;
}

.titulo-descricao-lote {
  display: flex;
  flex-direction: column;
  width: 50% !important;
  font-size: 12px;
  gap: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 10px;
  height: 100%;
}

.descricao-max-content {
  max-height: 476px;
  max-width: 370px;
  overflow: auto;
  padding: 5px;
}

.descricao-max-content::-webkit-scrollbar {
  width: 6px;
}

.descricao-max-content::-webkit-scrollbar-track {
  background: #fff;
}

.descricao-max-content::-webkit-scrollbar-thumb {
  background-color: #8f8f8f;
  border-radius: 20px;
}

.nm-titulo-lote {
  font-weight: 700;
  color: #1c2d47;
  margin-left: 5px;
}

.esquerda-meio-direita {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;
}

.content-lote-divider {
  border: 1px solid #dedede;
}

.esquerda {
  display: flex;
  flex-direction: column;
  width: 50% !important;
  gap: 1rem;
}

.carousel-lote-aberto {
  display: grid;
  flex-direction: column;
  width: 100%;
}

.content-imagem-visivel {
  width: 100%;
  border-radius: 10px;
  transition: 0.3s ease-in-out;
  height: fit-content;
}

.content-imagem-visivel:hover {
  scale: 1.01;
  transition: 0.3s ease-in-out;
}

.selecionar-lote {
  color: #fff;
  padding: 5px 11px;
  font-size: 15px;
  font-weight: 500;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #4A6A9A;
  border-radius: 4px;
}

.navegacao-lotes {
  border-radius: 4px;
  background-color: #4A6A9A;
  color: #fff;
  display: flex;
  align-items: center;
}

.navegacao-lotes .link-navegacao {
  padding: 0 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.fotos-grid {
  display: flex;
  gap: 18px;
  max-width: 393px;
  width: 100%;
  overflow-x: auto;
  height: fit-content;
  scroll-behavior: smooth;
}

.fotos-grid::-webkit-scrollbar {
  height: 6px;
}

.fotos-grid::-webkit-scrollbar-track {
  background: #fff;
}

.fotos-grid::-webkit-scrollbar-thumb {
  background-color: #1C2D47;
  border-radius: 20px;
}

.foto-item {
  flex: 0 0 calc((100% - 200px) / 3);
}

.fotos-grid img {
  min-width: 119px;
  height: auto;
  margin-bottom: 1rem;
}

.link-anexo-lote {
  color: #fff;
  background-color: #1C2D47;
  padding: 5px 11px;
  border-radius: 4px;
  font-size: 12px;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.link-anexo-lote:hover {
  background-color: #3a5d93;
  transition: 0.2s;
}

.link-anexo-lote-meireles {
  background-color: #e67a1a;
  color: #fff;
  padding: 5px 11px;
  border-radius: 4px;
  font-size: 12px;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.link-anexo-lote-meireles:hover {
  background-color: rgba(230, 122, 26, 0.5);
  transition: 0.2s;
}

.descricao-lote_area_lance {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.lotes-repasse-retirado {
  display: flex;
  gap: 1rem;
}

.lote-anexos-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  margin-top: 1rem !important;
  gap: 1rem;
  padding: 1rem;
}

.lote-anexos-grid .anexo {
  display: grid;
  justify-content: normal;
  align-items: center;
  text-align: center;
}

.icon-anexo {
  filter: invert(1);
  width: 20px;
  height: 20px;
}

@media (max-width: 1024px) {
  #lotes_retirados, #lotes_repasse {
    max-width: 448px;
  }
}

@media (max-width: 768px) {
  .descricao-lote_area_lance {
    flex-direction: column;
    width: 50%;
  }

  .titulo-descricao-lote {
    width: 100% !important;
  }

  .lotes-repasse-retirado {
    flex-direction: column !important;
  }

  #lote-anexos,
  #lote-messages {
    display: none;
  }

  .bloco-extra {
    justify-content: space-between;
    display: flex;
    min-height: 451px;
  }

  .link-anexo-lote {
    padding: 4px 10px;
  }

  .lote-anexos-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .fotos-grid img {
    min-width: 102px;
  }

  #lotes_retirados, #lotes_repasse {
    max-width: 678px;
  }
}

@media (max-width: 435px) {
  .esquerda-meio-direita {
    flex-direction: column;
  }

  .esquerda {
    width: 100% !important;
  }

  .descricao-lote_area_lance {
    width: 100%;
  }

  .navegacao-visitas {
    justify-content: space-between;
    width: 100%;
  }

  .status-lote {
    justify-content: center;
    display: flex;
    font-weight: bold;
  }

  .lote-anexos-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    justify-content: space-between;
  }

  .fotos-grid {
    max-width: 312px;
  }

  .fotos-grid img {
    min-width: 97px;
  }
}

@media (max-width: 360px) {
  .fotos-grid {
    max-width: 264px;
  }

  .fotos-grid img {
    min-width: 81px;
  }
}

@keyframes fa-blink {
  0% {
    opacity: 1;
    color: white;
    background: #67302b;
  }
  50% {
    opacity: 0.6;
    color: white;
    background: #67302b;
  }
  100% {
    opacity: 1;
    color: white;
    background: #67302b;
  }
}

.fa-blink {
  -webkit-animation: fa-blink 1.4s linear infinite;
  -moz-animation: fa-blink 1.4s linear infinite;
  -ms-animation: fa-blink 1.4s linear infinite;
  -o-animation: fa-blink 1.4s linear infinite;
  animation: fa-blink 1.4s linear infinite;
}


/* zoom slide */
.zoom-product-img .thumb-list {
  width: 26% !important;
  margin-top: -12px;
  margin-bottom: 15px;
  display: inline-box;
  display: -webkit-inline-box;
}

.zoom-product-img .text-right {
  float: right !important;
}

.zoom-product-img .fa {
  font-size: 30px;
}

/* EFEITO DE TRANSIÇÃO */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ESTILO LOTEABERTO - LAYOUT */
#portotemplate {
  background: #f2f2f2;
}

.lt-layout {
  margin-bottom: 20px;
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  color: #333;
}

.lt-wrapper {
  min-height: 200px;
  background: #fff;
  border-bottom: 1px solid #ddd;
}

.lt-header {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid #908b8b;
}

.lt-header h2 {
  padding: 15px 15px 0;
  font-weight: 700 !important;
  color: #fff !important;
}

#prevnext_lotes {
  margin-top: 16px;
}

#portotemplate .product-details-box .product-nav-container .product-nav a {
  color: #fff !important;
}

#portotemplate
.product-details-box
.product-nav-container
.product-nav
a:hover {
  color: #000 !important;
}

.lt-fotos {
  border-right: 1px solid #ddd;
  min-height: 100px !important;
  padding-top: 15px;
}

.lt-chat {
  padding: 0 !important;
  border-left: 1px solid #ddd;
}

.lt-fotos .control {
  font-size: 40px !important;
}

.lt-lance {
  padding: 32px !important;
}

.add-favorito {
  text-align: right;
  font-size: 20px;
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  color: #67302b;
  border-radius: 30px;
  padding: 6px 4px 4px 6px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.style-descricao {
  overflow: auto;
  max-height: 200px;
}

.envia_limite_lance {
  padding: 2px 6px;
  background: #cccbcb;
  border-radius: 14px;
  cursor: pointer;
  border: 1px solid #afadad;
}

.lt-abas {
  padding: 0 !important;
  margin: -0.01%;
}

.tabs-component,
.repasse-area {
  padding: 20px;
}

.repasse-area {
  border-top: 1px solid #ddd;
}

.repasse-area h4 {
  color: #633834 !important;
  font-weight: 600 !important;
}

.lotes-repasse {
  max-height: 270px;
  overflow: auto;
}

.repasse a {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.repasse a p {
  margin: 0 !important;
}

.repasse {
  margin: 2px;
  width: 80px;
  display: inline-block;
  border-radius: 3px;
  text-align: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  background: #034576;
  justify-content: center;
  height: 60px;
}

.retirado {
  background: rgb(208, 0, 0) !important;
}

.repasse:hover, .retirado:hover {
  text-decoration: none !important;
  background: #9f9f9f !important;
}

.repasse a,
.repasse p {
  color: #fff;
  text-decoration: none;
}

#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 200px;
}

#portotemplate .spinner div {
  background-color: #67302b !important;
}

.role-descricao {
  display: none;
}

@media (min-width: 800px) {
  .v--modal-box {
    width: 500px !important;
  }
}

.title-h {
  color: #67302b;
  font-weight: 700 !important;
  font-size: 20px !important;
  background: #fff;
  padding: 10px 10px 14px;
  margin: 0 0 1px !important;
}

/* TABS ESTILO */

/* MEDIA QUERIES LAYOUT(RESPONSIVO) */
@media (max-width: 980px) {
  .tabs-component-tab {
    width: 95%;
    margin-left: 2.4%;
  }

  div#prevnext_lotes {
    position: absolute !important;
    top: -70px !important;
    right: 2px !important;
  }
}

@media (max-width: 900px) {
  .lt-chat {
    min-height: auto !important;
    margin-bottom: 80px !important;
  }

  #btn_enviamensagemchat {
    padding: 18px 10px;
  }

  button {
    margin: 0 !important;
  }
}

@media (max-width: 550px) {
  #btn_enviamensagemchat {
    padding: 9px 10px;
  }

  .lt-header {
    text-align: center;
  }

  h1.title-header-area {
    font-size: 25px !important;
    font-weight: 700 !important;
  }

  .style-descricao {
    max-height: 250px;
  }

  .role-descricao {
    display: initial;
    position: absolute;
    text-align: center;
    width: 83%;
    margin-top: 2rem;
    color: #e36159;
  }
}

.total-de-lances {
  color: #67302b;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}

.total-de-lances .count-lances {
  margin-top: 6px;
}

.repasse_i,
.repasse__lance_i,
.retirado_i,
.cancelado_i,
.excluido_i {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 10px;
}

.repasse_i {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(122 156 96 / var(--tw-bg-opacity)) !important;
}

.repasse__lance_i {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(21 31 45 / var(--tw-bg-opacity)) !important;
}

.retirado_i {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(152 83 83 / var(--tw-bg-opacity)) !important;
}

.cancelado_i {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity)) !important;
}

.excluido_i {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 102 113 / var(--tw-bg-opacity)) !important;
}

#lotes_retirados, #lotes_repasse {
  max-width: 580px;
  overflow-x: auto;
  display: flex;
}

#lotes_retirados::-webkit-scrollbar {
  height: 10px;
}

#lotes_retirados::-webkit-scrollbar-thumb {
  background: #0a1a3d;
  border-radius: 5px;
}

#lotes_repasse::-webkit-scrollbar {
  height: 10px;
}

#lotes_repasse::-webkit-scrollbar-thumb {
  background: #0a1a3d;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoteAberto.vue